import { Card, CardContent, CardHeader, Stack, Typography } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { getAppConfig } from "../../../../config/config";

export const HomepageCard = () => {
  const { t } = useTranslation(["home"]);

  return (
    <Card>
      <CardHeader subheader={t("home:home.welcome.card.sub.title")} title={t("home:home.welcome.card.title")} />
      <CardContent>
        <Stack spacing={1}>
          <Typography>{t("home:home.welcome.card.body.1")}</Typography>
          <Typography sx={{ fontWeight: "bold" }}>{t("home:home.welcome.card.listing.1.header")}</Typography>

          <Stack component="ul" pl={2}>
            <Stack component="li" direction="row">
              <Typography sx={{ fontWeight: 600 }}>{t("home.welcome.card.listing.1.column.1.title")}&nbsp;</Typography>
              <Typography>{t("home.welcome.card.listing.1.column.1.label")}</Typography>
            </Stack>
            <Stack component="li" direction="row">
              <Typography sx={{ fontWeight: 600 }}>{t("home.welcome.card.listing.1.column.2.title")}&nbsp;</Typography>
              <Typography>{t("home.welcome.card.listing.1.column.2.label")}</Typography>
            </Stack>
            <Stack component="li" direction="row">
              <Typography sx={{ fontWeight: 600 }}>{t("home.welcome.card.listing.1.column.3.title")}&nbsp;</Typography>
              <Typography>{t("home.welcome.card.listing.1.column.3.label")}</Typography>
            </Stack>
          </Stack>

          <Typography>{t("home:home.welcome.card.body.2")}</Typography>
          <Typography sx={{ fontWeight: "bold" }}>{t("home:home.welcome.card.body.3")}</Typography>

          <Typography>
            {t("home:home.welcome.card.body.4.1")}&nbsp;
            <a href="https://bvhi.org/hidatasync" rel="noreferrer" target="_blank">
              {t("home:home.welcome.card.bvhi.url")}
            </a>
            &nbsp;{t("home:home.welcome.card.body.4.2")}
          </Typography>
        </Stack>
      </CardContent>
      <CardHeader subheader={t("home:home.welcome.card.sub.title.2")} title={t("home:home.welcome.card.title.2")} />
      <CardContent>
        <Stack spacing={1}>
          <Typography sx={{ fontWeight: 600 }}>{t("home:home.welcome.card.technical.support.header")}</Typography>
          <Typography>{t("home:home.welcome.card.technical.support.body")}</Typography>
          <Typography>
            {t("home:home.welcome.card.technical.support.email")}&nbsp;
            <a href={`mailto:${getAppConfig().env.supportMailAdesso}`}>{getAppConfig().env.supportMailAdesso}</a>
          </Typography>
          <Typography>{t("home:home.welcome.card.technical.support.phone")}</Typography>
          <Typography>
            {t("home:home.welcome.card.general.support.body")}&nbsp;
            <a href="https://bvhi.org/hidatasync" rel="noreferrer" target="_blank">
              {t("home:home.welcome.card.general.support.link.label")}
            </a>
            .
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
